import { h } from 'preact'
import { Text } from 'preact-i18n'

export default ({name, label = "", required, children}, context) => {
    let error = context.form.error[name];
    return (
        <div class={`form-group${error ? ' parsley-error' : ''}`}>
            <div class="input checkbox">
                <div class="form-check">
                    <label class="add-on form-check-label" for={name}>
                        <input 
                            class={error ? "parsley-error" : ""}
                            id={name}
                            name={name} 
                            checked={context.form.data[name]} 
                            onChange={e => context.form.setValue(name)($(e.target).is(':checked'))} 
                            onBlur={e => context.form.setValue(name)($(e.target).is(':checked'))} 
                            type="checkbox"
                        />
                        <span>{children} {required && '*'}</span>
                    </label>
                </div>
                {error && 
                    <ul class="parsley-errors-list filled">
                        <li><Text id={ "validationError." + error }>{error}</Text></li>
                    </ul>
                }
            </div>
        </div>
    );
}


// WEBPACK FOOTER //
// ./js/components/Form/Checkbox.js